import React__default from 'react';
import { ButtonGroupLayout, ButtonGroupAlignment, ButtonGroupSlotType } from './types.js';
import { ButtonGroupWrapper, ButtonGroupSpacer } from './styles.js';
import Slot from './Slot.js';
import { Spacing } from '@doordash/design-language';
import { ButtonType } from '@doordash/component-button';

var TOTAL_NUMBER_OF_COLUMNS = 3;

var ButtonGroup = function ButtonGroup(_ref) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? ButtonGroupLayout.Split : _ref$layout,
      _ref$insetSize = _ref.insetSize,
      insetSize = _ref$insetSize === void 0 ? Spacing.Small : _ref$insetSize,
      insetHorizontalSize = _ref.insetHorizontalSize,
      insetVerticalSize = _ref.insetVerticalSize,
      _ref$insetProps = _ref.insetProps,
      insetProps = _ref$insetProps === void 0 ? {} : _ref$insetProps,
      _ref$itemGap = _ref.itemGap,
      itemGap = _ref$itemGap === void 0 ? Spacing.XxSmall : _ref$itemGap,
      _ref$itemAlignment = _ref.itemAlignment,
      itemAlignment = _ref$itemAlignment === void 0 ? ButtonGroupAlignment.Center : _ref$itemAlignment,
      primaryAction = _ref.primaryAction,
      secondaryAction = _ref.secondaryAction,
      tertiaryAction = _ref.tertiaryAction,
      useDynamicPadding = _ref.useDynamicPadding;
  var columnCount = 0;

  if (layout === ButtonGroupLayout.Split) {
    columnCount = TOTAL_NUMBER_OF_COLUMNS;
  } else {
    if (primaryAction) {
      columnCount += 1;
    }

    if (secondaryAction) {
      columnCount += 1;
    }

    if (tertiaryAction) {
      columnCount += 1;
    }
  } // We always render a slot for the split layout, as we want to have a <ButtonGroupSpacer />
  // For other layouts we don't want that, so we will forego rendering if a slot is not passed.


  var shouldRenderTertiarySlot = layout === ButtonGroupLayout.Split || tertiaryAction;
  var shouldRenderSecondarySlot = layout === ButtonGroupLayout.Split || secondaryAction;
  var shouldRenderPrimarySlot = layout === ButtonGroupLayout.Split || primaryAction;
  return /*#__PURE__*/React__default.createElement(ButtonGroupWrapper, {
    layout: layout,
    columnCount: columnCount,
    insetSize: insetSize,
    insetHorizontalSize: insetHorizontalSize,
    insetVerticalSize: insetVerticalSize,
    insetProps: insetProps,
    itemGap: itemGap,
    itemAlignment: itemAlignment,
    useDynamicPadding: useDynamicPadding
  }, shouldRenderTertiarySlot && /*#__PURE__*/React__default.createElement(Slot, {
    slot: tertiaryAction,
    slotType: ButtonGroupSlotType.Tertiary
  }), layout === ButtonGroupLayout.Split && /*#__PURE__*/React__default.createElement(ButtonGroupSpacer, null), shouldRenderSecondarySlot && /*#__PURE__*/React__default.createElement(Slot, {
    slot: secondaryAction,
    slotType: ButtonGroupSlotType.Secondary
  }), shouldRenderPrimarySlot && /*#__PURE__*/React__default.createElement(Slot, {
    slot: primaryAction,
    slotType: ButtonGroupSlotType.Primary
  }));
};

ButtonGroup.Spacing = Spacing;
ButtonGroup.Layouts = ButtonGroupLayout;
ButtonGroup.Alignments = ButtonGroupAlignment;
ButtonGroup.ButtonTypes = ButtonType;

export { ButtonGroup as default };
